/**
 * Filter topic string to only include parent topics i.e. category only
 * @param topicString - The topic string to filter
 * @returns True if the topic string is a parent topic, false otherwise
 */
export default function filterTopicStringChild(topicString: string): boolean {
  // If the topic string includes a pipe, it is a parent topic
  return topicString.includes('|');
}
